module.exports = __webpack_public_path__ + "static/media/beaktiv.42ac195a.jpg";